import { z } from "zod";

const CountryReportDataV4Schema = z.object({
    country: z.string(),
    nb_reservations: z.number().int(),
    amount: z.string(),
});

const CountryReportTotalV4Schema = z.object({
    nb_reservations: z.number().int(),
    amount: z.string(),
});

export const CountryReportResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(CountryReportDataV4Schema),
    total: CountryReportTotalV4Schema,
});

export type CountryReportDataV4 = z.infer<typeof CountryReportDataV4Schema>;
export type CountryReportResponseV4 = z.infer<typeof CountryReportResponseV4Schema>;